import { ActiveFilters, FilterGroup } from './types';

import classes from './style.module.css';

type FilterButtonsProps = {
  filterGroups: FilterGroup<any>[];
  handleFilterChange: (groupId: string, filterName: string) => void;
  activeFilters: ActiveFilters;
};

export const FilterButtons = (
  { filterGroups, handleFilterChange, activeFilters }: FilterButtonsProps,
) => {
  return (
    <>
      {filterGroups.map(({ groupId, filters }) => (
        <div key={groupId} className={classes.filterGroup}>
          {filters.map(({ name }) => (
            <button
              type="button"
              key={name}
              className={`${classes.filterButton} ${activeFilters[groupId] === name ? classes.filterButtonActive : ''}`}
              onClick={() => handleFilterChange(groupId, name)}
            >
              {name}
            </button>
          ))}
        </div>
      ))}
    </>
  );
};
